module.exports = __webpack_public_path__ + "static/media/googleLogo.b7727941.svg";